import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://public.readdy.ai/ai/img_res/a7c6a7f2-4945-4249-b551-f74c8da4a469.png"
              alt="FIRETRAUMAS Logo"
              className="h-12 w-auto"
              loading="eager"
              fetchpriority="high"
            />
            <span className={`font-serif font-bold text-xl ${isScrolled ? 'text-primary' : 'text-white'}`}>
              FIRETRAUMAS
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-secondary'
                    : isScrolled
                    ? 'text-primary hover:text-secondary'
                    : 'text-white hover:text-secondary'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+34690220944"
              className="bg-secondary text-white px-6 py-2.5 rounded-full font-sans text-sm font-semibold hover:bg-opacity-90 transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              690 22 09 44
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-md ${isScrolled ? 'text-primary' : 'text-white'}`}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 font-sans text-sm font-medium ${
                  location.pathname === link.path ? 'text-secondary' : 'text-primary hover:text-secondary'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+34690220944"
              className="block bg-secondary text-white px-6 py-2.5 rounded-full font-sans text-sm font-semibold text-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              690 22 09 44
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}